import React from 'react';

import { Animation } from 'components/lottie-animations/order-confirmation';

export const CheckoutIcon = ({ isPaused = false }) => <Animation isPaused={isPaused} />;
